import * as React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { TIMEOUT_HM_MODAL_MESSAGE } from '../../../../../constant/constants';

interface Props {
  errorMessage: string;
}

const Error: React.FC<Props> = ({ errorMessage }) => {
  const { t } = useTranslation();

  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(false);
    }, TIMEOUT_HM_MODAL_MESSAGE);

    return () => clearTimeout(timeout);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <>
      {createPortal(
        <div className="overlay_modal">
          <div className="modal_content">{t(`healthMonitor.deviceDetails.error.${errorMessage}`)}</div>
        </div>,
        document.getElementById('root_overlay')!,
      )}
    </>
  );
};

export default Error;
